$(document).ready(function(){
	var res_slider=$('.resource-slider');
  	var width; 
  	var scaleFontElements=$('[data-scale-fonts]');
  	var scale;
	$(window).on('resize', function(){
		$('#navPanel').css('margin-top',$('html').css('margin-top'));
		scaleFontElements.each(function(){
			scale=$(this).outerWidth()/$(this).data('scale-fonts')*100;
			if(scale>100)
				scale=100;
			$(this).css('font-size',scale+'%');
		});
		width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		if (width < 1030)
		{
			if (res_slider.hasClass('slick-initialized'))		
				res_slider.slick('unslick');	
      res_slider.show();	
			return;
		}

		if (!res_slider.hasClass('slick-initialized'))
		{
			res_slider.slick({
  				slidesToShow: 3,
  				slidesToScroll: 1,
  				prevArrow:'<i class="prev fa fa-angle-left"></i>',
  				nextArrow:'<i class="next fa fa-angle-right"></i>',
  				easing:'easeInOutQuad',
  				/*responsive: [
  				{
  				breakpoint: 900,
  				settings: "unslick"
  				}
  				]*/
  			});
        res_slider.show();
  			return;
  		}
	});
	

	 $(
      '<div id="navPanelHolder"><div id="navPanel">' +
      	'<div class="mobile-lang-switcher">'+ $('.mobile-lang-switcher').html() + '</div>' +
        '<nav>' +
          $('.site-header nav').navList() +
        '</nav>' +
          $('#footer nav').html() + 
          $('#footer .footer-search .search').html() +
          '<div class="social">'+ $('#footer .social').html() + '</div>' +
      '</div></div>'
    )
      .appendTo($('body')).find('#navPanel')
      .panel({
        delay: 500,
        hideOnClick: true,
        hideOnSwipe: true,
        resetScroll: true,
        resetForms: true,
        side: 'right',
        target: $('body'),
        visibleClass: 'navPanel-visible'
      });
    var mobile_search=false;
    $('.mobile-search i').click(function(){
    	if(mobile_search)
    		return;
    	var expand=$('.expand-search');
    	var search=$('.mobile-search');
    	if(expand.is(':visible'))
    		search.removeClass('active');
    	else
    		search.addClass('active');
    	mobile_search=true;
    	expand.slideToggle(function(){
    		mobile_search=false;
    	});
    });


    $('.expanding-content .top').click(function(){
      var holder=$(this).closest('.expanding-content');
      holder.toggleClass('active');
      if(holder.is('.active'))     
        $('.content, .top .svg-holder',holder).slideDown();
      else
        $('.content, .top .svg-holder',holder).slideUp();
    });
    $('nav.secondary-nav-mobile span').click(function(){
      var target=$(this).closest('.secondary-nav-mobile').find('ul');
      var container=$(this).closest('.secondary-nav-mobile');
      if(container.hasClass('open'))
      {
        target.slideUp();
        container.removeClass('open');
      }
      else
      {
        target.slideDown();
        container.addClass('open');
      }      
    });
    $(window).resize();


    $('a.video').magnificPopup({
      type: 'iframe'
    });
    $( document.body ).on('adding_to_cart',function(e,button,data){      
      if(button.attr('type')=="submit")
      {
        data['quantity']=button.closest('form').find('input[name="quantity"]').val();
      }
    });


    $('.loadmore').click(function(){
      var that=$(this);
      if(that.data('clickable')===false)
        return;
      var type="", displayType="";
      if(that.is('.partner'))
        type='partner';
      if(that.is('.leader'))
        type='leader';

      if(type=="")
        return;

      if(that.is('.grid'))
        displayType='grid';
      if(that.is('.list'))
        displayType='list';
  
      if(displayType=="")
        return;

      that.data('clickable',false);
      var page=that.data('page');
      if(typeof page=="undefined")
        page=2;

      $.post(psURL,{"ps-more":type,page:page,'display-type':displayType},function(resp){
        if(typeof resp.success != "undefined"&&resp.success)
        {          
          if(resp.html=="")
          {
            that.hide();
            return;
          }
          that.prev('.partner-'+displayType).append(resp.html);
          that.data('page',page+1);
          that.data('clickable',true);          
        }        
      },'json');

      
    });
    $( document.body ).on('wc_fragments_loaded',function(a,b,c){
      $('.nav-cart').each(function(){
        var num=parseInt($('.count .num',this).html());
        if(num>0)
          $(this).removeClass('empty');
      });
    });
    $('.newsletter-popup-open').click(function(e){
      e.preventDefault();
      var parent=$(this).closest('.ps-subscribe');
      var email='';
      if(parent.length>0)
        email=$('.email',parent).val();
      if(typeof email == "undefined")
        email='';
      $('.newsletter-popup input[type="email"]').val(email);
      afterCloseNavPanel(function(){
        $.magnificPopup.open({
          items: {
              src: '.newsletter-popup',
              type: 'inline'
          },
          removalDelay: 400,
            mainClass: 'mfp-fade'
        });
      });
    });
    function afterCloseNavPanel(func)
    {
      if($('body').hasClass('navPanel-visible')&&$('#navPanel').offset().left<$(window).width())
      {
        $('.mobile-nav').click();
        setTimeout(func,500);
      }
      else
      {
        func();
      }
      
    }
    $('button[type=reset]').click(function(){
      $(this).closest('form').find('input:checkbox').removeAttr('checked');
      $(this).closest('form').find('input[type=text]').val();
    });

    

    if(typeof Marionette != "undefined")
    {
      var nfcontroller = Marionette.Object.extend( {
        initialize: function() {
            var initChannel = Backbone.Radio.channel( 'form' );
            this.listenTo( initChannel, 'render:view', nf_init );  


            


            //var fieldsChannel = Backbone.Radio.channel( 'fields' );  
           // this.listenTo( fieldsChannel, 'add:error', addError );        
        }
      });
      new nfcontroller();
    }   
    function nf_init(f)
    {
      var fieldModel=f.model;
      $('.nf-field-container.age-group input').change(function(){
        var fieldContainer=$(this).closest('.nf-field-container');
        var form=$(this).closest('.nf-form-wrap');
        var target=form.find('.age-group-'+$('input:checked',fieldContainer).val());
        form.find('.hide').not(target).hide();
        target.show();     
      }).first().change();

     
      var original_html=$(f.el+' .submit2').html();
      $(f.el+' .submit2').click(function(){
        var formModel = nfRadio.channel( 'app' ).request( 'get:form', fieldModel.get( 'id' ) );
        nfRadio.channel( 'form-' + fieldModel.get( 'id' ) ).request( 'submit', formModel );
      
        
      });

      var nfcontroller = Marionette.Object.extend( {
        initialize: function() {
            var initChannel = Backbone.Radio.channel(  'form-' + fieldModel.get( 'id' ) );
            this.listenTo( initChannel, 'before:submit', function(){
              $(f.el+' .submit2').html('<span>...</span>');
            } ); 
            this.listenTo( initChannel, 'submit:failed', function(){
              $(f.el+' .submit2').html(original_html);
            } ); 
            


            


            //var fieldsChannel = Backbone.Radio.channel( 'fields' );  
           // this.listenTo( fieldsChannel, 'add:error', addError );        
        }
      });
      new nfcontroller();

/*
      var fieldsChannel = Backbone.Radio.channel( 'fields' );  
      fieldsChannel.on('add:error',function(a,b,c){
        
      });
      */
    }
   
     function addError(a,b,c)
    {
      console.log(a);
      console.log(b);
      console.log(c);
    }


    $('input.date-picker').datepicker();

    $('.expand-more-content').click(function(){
      $(this).siblings('.more-content').slideDown();
      $(this).slideUp();
      $(this).unbind('click');
    });
    $('.mobile-lang-switcher').click(function(){
      $('ul',this).slideToggle();
    });
    $(document).on('click','a:not(.ok, .bypass, .video)',function(e){    
      if($(this).closest('.ssba-wrap').length>0)
        return; 
      var url=$(this).attr('href');
      var matches = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
      var domain = matches && matches[1];
      if(domain!=null&&domain!=window.location.host)
      {
        e.preventDefault();
        $('.leaving-popup .ok').attr('href',url);
        $.magnificPopup.open({
          items: {
              src: '.leaving-popup',
              type: 'inline'
          },
          removalDelay: 400,
            mainClass: 'mfp-fade'
        });
      }
    });
    $('.leaving-popup .cancel, .leaving-popup .ok').click(function(){
      $.magnificPopup.close();
    });
    $('.sort .sort-type').click(function(){
      $('ul',this).slideToggle();
    });
    $('.sort .sort-type a').click(function(){
      var arrow=$(this).closest('.sort-type').children().clone();
      $(this).closest('.sort-type').html($(this).html()+" ").append(arrow);
    });

    /*
    wc_fragments_refreshed
    */

    $("#billing_phone").mask("999-999-9999");


    $( document.body ).on( 'adding_to_cart', function(e,$thisbutton, data){
      if(typeof data.product_id != "undefined")
      {
        var val=$thisbutton.closest('form').find('[name=language]').val();
        if(typeof val != "undefined")
          data.product_id=val;
      }
    } );

    $('.newsletter-signup').submit(function(e){
      e.preventDefault();
      var form=$(this);
      if(form.data('processing'))
        return;
      form.data('processing',true);
      $('.response',form).html('');
      var submit=$('input[type="submit"]',form);
      var submitval=submit.val();
      submit.val('.');
      var updateSubmit=setInterval(function(){
        if(submit.val().length>2)
          submit.val('.');
        else
          submit.val(submit.val()+'.');
      },500);
      $.post('/',form.serialize()+'&ajax=1',function(resp){
        if(resp.data)
        {
          $('.response',form).html(resp.data);
        }
        else
        {
          $('.response',form).html('Server error');
        }
      }).fail(function(){
        $('.response',form).html('Server error');
      }).always(function(){
        form.data('processing',false);
        clearInterval(updateSubmit);
        submit.val(submitval);
      });
    });
    $('.readmore-container').each(function(){
      var button=$('<button type="button" class="read-more-button">'+load_more_text+' <i class="fa fa-arrow-down" aria-hidden="true"></i></button>');
      $(this).data('button',button);
      button.data('container',$(this));
      $(this).after(button);
      button.click(function(){
        if($(this).data('container').is(":hidden"))
          $(this).html(show_less_text+' <i class="fa fa-arrow-up" aria-hidden="true"></i>').addClass('open');
        else
          $(this).html(load_more_text+' <i class="fa fa-arrow-down" aria-hidden="true"></i>').removeClass('open');
        $(this).data('container').slideToggle();
      });
    });
    $('.press-kit-page .sidebar a').smoothScroll({offset: -30});
    $('.ssba a').click(function(){
      if(typeof ga != 'undefined')
      {
        ga('send','event','Outbound','share',$('img',this).attr('title'));
      }
      else
      {
        console.log(['share',$('img',this).attr('title')]);
      }
    });
    $('.quiz-wrap .top button').click(function(){
      $(this).closest('.quiz-wrap').find('.expand').slideToggle();
      $(this).closest('.quiz-wrap').find('.quiz').toggleClass('open');
    });
    if($('.quiz-wrap form input:checked').length>0 || window.location.hash=="#open-quiz")
    {
      $('.quiz-wrap .expand').slideToggle();
      $('.quiz-wrap .quiz').toggleClass('open');
    }
});


/* home2 */
$(document).ready(function(){

    $('.home2 .videos').slick({
        autoplay: false,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        fade: true,
    });

    $('.home2 .next-bar a.next').click(function(){
       $('.videos').slick('slickNext');
       return false;
    });
    $('.home2 .next-bar a.prev').click(function(){
       $('.videos').slick('slickPrev');
       return false;
    });

    $('.home2 .circles-desktop li').click(function(){
        if(!$(this).hasClass('open')){
            $('.home2 .circles-desktop li').removeClass('open');
            $(this).addClass('open');
            $('.home2 .tips .tabs li').hide();
            var  c = $('.home2 #' + $(this).attr('id') + '-content');
            $(c).prependTo($(c).parent()).fadeIn(230);
        }
    });

    $('.home2 .tabs .title').click(function(){
        $(this).toggleClass('open');
        $(this).next().slideToggle(180).toggleClass('open');
        return false;
    });


    // $('.tabs .title, .tabs .tab-content').each(function(){
    //    if(!$(this).hasClass('tab-default')){
    //        TweenLite.set($(this), {autoAlpha: 0, scale: .5});
    //        $(this).show();
    //    }
    // });


});

$(window).on('load', function(){
    $('.home2 .slider-holder').removeClass('loading');
});
